/* import __COLOCATED_TEMPLATE__ from './ticket-status-select.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type TicketStateService from 'embercom/services/ticket-state-service';
import type Conversation from 'embercom/objects/inbox/conversation';
import type { TicketType } from 'embercom/objects/inbox/ticket';
import { localisedCustomStateAdminLabel } from 'embercom/lib/inbox2/ticket-custom-states';
import type IntlService from 'embercom/services/intl';

interface DropdownItem {
  value: number;
  text: string;
  component: string;
  componentAttrs: { state: import('embercom/objects/inbox/ticket-custom-state').default };
}

interface Args {
  selectedTicketType: TicketType;
  originalConversation: Conversation;
  selectedValue: number | undefined;
  onSelect: (customStateId: number) => void;
  hasError?: boolean;
}

interface Signature {
  Args: Args;
}

export default class TicketStatusSelect extends Component<Signature> {
  @service declare ticketStateService: TicketStateService;
  @service declare intl: IntlService;
  @service declare inboxHotkeys: $TSFixMe;

  get hasError(): boolean {
    return this.args.hasError ?? false;
  }

  get availableStates() {
    return this.ticketStateService.getLiveCustomStatesForTicketType(this.args.selectedTicketType);
  }

  get selectedState() {
    if (this.args.selectedValue == null) {
      return undefined;
    }
    return this.availableStates.find((s) => s.id === this.args.selectedValue);
  }

  get dropdownItems(): DropdownItem[] {
    return this.availableStates.map((state) => ({
      value: state.id,
      text: localisedCustomStateAdminLabel(state.adminLabel, this.intl),
      component: 'inbox2/ticket-attribute/ticket-status-select-item',
      componentAttrs: { state },
    }));
  }

  @action
  onSelectItem(customStateId: number) {
    this.args.onSelect(customStateId);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::TicketAttribute::TicketStatusSelect': typeof TicketStatusSelect;
    'inbox2/ticket-attribute/ticket-status-select': typeof TicketStatusSelect;
  }
}
